import { useQuery } from "react-query";
import axios from "../axios";

const useGetItemsDonateToCharity = ({ seller_id }) => {
  const query = useQuery("items-donate-to-charity", async () => {
    try {
      return await axios.get(
        `/api/v2/product/charity?id=${seller_id}&page=1&limit=30`
      );
    } catch (error) {
      console.log(error);
    }
  });

  return query;
};

export default useGetItemsDonateToCharity;
